var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71439 7C4.32376 7 4.0074 7.43559 4.0074 7.97349H5.42161C5.42156 7.43551 5.10475 7 4.71439 7ZM9.42885 8.4834H0V10.7069H9.42885V8.4834ZM23.2852 11.4246C22.6014 11.4246 22.047 12.1871 22.047 13.127V14.2678L18.6424 15.1745C18.0858 15.1745 17.4667 14.9593 16.7851 14.7223C15.9504 14.4321 15.022 14.1093 13.9999 14.1093C12.9774 14.1093 12.0488 14.4321 11.2141 14.7223C10.5325 14.9593 9.91352 15.1745 9.35699 15.1745L5.95221 14.2678V13.127C5.95221 12.1872 5.39807 11.4246 4.71426 11.4246C4.03039 11.4246 3.47625 12.1871 3.47625 13.127V18.4501C3.47625 19.3899 4.03034 20.1526 4.71426 20.1526C5.39807 20.1526 5.95221 19.3899 5.95221 18.4501V17.4467C6.94139 17.7313 8.3048 18.1206 9.20228 18.3678C9.82144 18.538 10.2672 19.1512 10.7575 19.8256C11.4929 20.8372 12.3285 21.9867 13.9999 21.9867C15.671 21.9867 16.5066 20.8373 17.242 19.8257C17.7324 19.1513 18.1782 18.5381 18.7974 18.3678C19.6947 18.1206 21.0579 17.7313 22.047 17.4467V18.4501C22.047 19.3899 22.6014 20.1526 23.2852 20.1526C23.969 20.1526 24.5232 19.3899 24.5232 18.4501V13.127C24.5232 12.1871 23.9691 11.4246 23.2852 11.4246ZM18.5709 8.4834H27.9999V10.7069H18.5709V8.4834ZM22.5782 7.97349C22.5782 7.43559 22.8947 7 23.2855 7C23.6756 7 23.9924 7.43551 23.9925 7.97349H22.5782Z",
    fill: "#0076CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlane);
export default __webpack_public_path__ + "static/media/icon_plane.aeef1fef32d38742ad9364b766228bd7.svg";
export { ForwardRef as ReactComponent };